<template>
    <div class="authen">
		<Loading v-if="!loading"/>
        <h3>实名认证</h3>
        <div class="form-item" v-if="loading">
            <p class="tag"><span v-show="authenStatus">*</span>身份证号</p>
            <input type="text" placeholder="请输入身份证号" @blur="checkIdCode" v-show="!authenStatus" v-model="authenForm.card">
            <p class="authen-suc-info" v-show="authenStatus">{{this.authenForm.card}}</p>
            <p class="error-text">{{idCardError}}</p>
        </div>
        <div class="form-item" v-if="loading">
            <p class="tag"><span v-show="authenStatus">*</span>姓名</p>
            <input type="text" placeholder="请输入姓名" @blur="checkName" v-show="!authenStatus" v-model="authenForm.name">
            <p class="authen-suc-info" v-show="authenStatus">{{this.authenForm.name}}</p>
            <p class="error-text">{{nameError}}</p>
        </div>
        <div class="form-item" v-if="loading">
            <p class="tag"><span v-show="authenStatus">*</span>手机号</p>
            <input type="text" placeholder="请输入手机号" @blur="checkPhone" v-show="!authenStatus" v-model="authenForm.phone">
            <p class="authen-suc-info" v-show="authenStatus">{{this.authenForm.phone}}</p>
            <p class="error-text">{{phoneError}}</p>
        </div>
        <button :class="{'submit-btn':true,'submiting':disabled}" :disabled="disabled" ref="sendBtn" @click="sendAuthen" v-show="!authenStatus">提交审核</button>
        <div class="authen-suc-icon" v-show="authenStatus"></div>
    </div>
</template>

<script>
import {Axios} from '@/assets/api/axios'
import Loading from '@/components/Loading'
import {phoneNumCheck} from '@/assets/api/validate'
import notifyIcon from '@/assets/img/msgicon.png'
export default {
    data(){
        return{
            authenStatus:'',         //根据实名状态判断显示输入框或者实名信息
			loading:false,           //控制加载页面显示隐藏
			idCardError:'',          //身份证填写错误提示
			nameError:'',            //真实姓名填写错误提示
			phoneError:'',           //手机号错误信息提示
			disabled:false,          //提交按钮是否可点击状态


			authenForm:{             //储存实名数据
				name: '',
                card:'',
                phone:''
			}
        }
	},
	created(){
        Axios.get('/user/info').then(
            response=>{
                if(response.data.code==200&&response.data.status=="success"){
					this.authenForm=response.data.data.real_name_arr
					this.authenStatus=response.data.data.real_name_auth
                    this.loading=true
                }
            }
        ).catch(
            error=>{
                console.log(error)
            }
        )
	},
	methods:{
		//检查身份证号是否18位
		checkIdCode(){
			if(this.authenForm.card.length!==18){
				this.idCardError="请输入18位身份证号"
			}else{
				this.idCardError=""
			}
		},
		//检查姓名位数是否大于1位
		checkName(){
			let reg = new RegExp("[\\u4E00-\\u9FFF]+$","g")
			if(!reg.test(this.authenForm.name)){
				this.nameError="请输入正确的姓名"
			}else{
				this.nameError=""
			}

		},
		//检查手机号格式是否正确
		checkPhone(){
			if(!phoneNumCheck(this.authenForm.phone)){
				this.phoneError="请输入正确手机号"
			}else{
				this.phoneError=""
			}
		},
		//发送实名验证表单
		sendAuthen(){
			this.checkIdCode()
			this.checkName()
			this.checkPhone()
			let validateRes=!this.idCardError&&!this.nameError&&!this.phoneError
			if(validateRes){
				this.disabled=true
				this.$refs.sendBtn.innerHTML="提交中..."
				Axios.post('card/auth',{card:this.authenForm.card,name:this.authenForm.name,phone:this.authenForm.phone}).then(
					response=>{
						if(response.data.status=='error'&&response.data.code==200){
							this.disabled=false
							this.$refs.sendBtn.innerHTML="提交审核"
							this.$swal({
								text:response.data.message,
								showConfirmButton:false,
								width:'6rem',
								padding:'0.5rem',
								timer:1200,
								imageWidth:50,
								imageHeight:50,
								imageUrl:notifyIcon,
								timerProgressBar: true
							});
						}else if(response.data.status=='success'&&response.data.code==200){
							this.authenStatus=false
							this.disabled=false
							this.$refs.sendBtn.innerHTML="提交审核"
							this.authenStatus=1
						}
					}
				).catch(
					error=>{
						this.$swal({
							text:'网络错误 请稍后重试',
							showConfirmButton:false,
							width:'6rem',
							padding:'0.5rem',
							timer:1200,
							imageWidth:50,
							imageHeight:50,
							imageUrl:notifyIcon,
							timerProgressBar: true
						});
					}
				)
			}
		}
	},
    components:{
        Loading
    }
}
</script>

<style lang="scss" scoped>
    .authen{
        padding:60px 44px;
        position:relative;
        padding-top:148px;
        h3{
            font-size:30px;
            color:#222;
            font-weight:bold;
            margin-bottom:60px;
        }
        .form-item{
            margin-bottom:30px;
            .tag{
                color:#333;
                font-size:24px;
                margin-bottom:30px;
                span{
                    color:#bf0000;
                }
            }
            input{
                width:640px;
                height:70px;
                border:none;
                border-radius:35px;
                background:#f7f7f7;
                color:#999;
                margin-bottom:12px;
                padding-left:20px;
				font-size:26px;
            }
            input::webkit-input-placeholder{
                color:#ccc;
            }
            .authen-suc-info{
                color:#222;
                font-size:24px;
                height:24px;
                font-weight:bold;
                margin-bottom:50px;
            }
            .error-text{
                padding-left:20px;
				height:24px;
                color:#bf0000;
				font-size:24px;
            }
        }
        .submit-btn{
            width:640px;
            height:70px;
            line-height:70px;
            text-align:center;
            color:#fff;
            background:#bf0000;
            border-radius:35px;
			font-size:26px;
			border:none;
        }
		.submiting{
			background:#dd8080;
		}
        .submit-btn:active{
            background:#dd8080;
        }
        .authen-suc-icon{
            width:142px;
            height:142px;
            background:url('../assets/img/authensuc.png') no-repeat;
            background-size:cover;
            position:absolute;
            top:150px;
            right:44px;
        }
    }
</style>